import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Outfit', sans-serif;

  .modal-header-sub-data {
    font-family: 'Outfit', sans-serif;
    &.center {
      text-align: center;
    }
  }

  h4.modal-header-sub-data {
    font-size: 24px;
    font-weight: 600;
    color: var(--text-main);
    margin-bottom: 8px !important;
  }

  p.modal-header-sub-data {
    font-size: 15px;
    color: var(--text-muted);
    margin-bottom: 32px !important;
  }

  .otp-cont {
    display: flex;
    justify-content: center;
    gap: 12px;
    margin-bottom: 32px;
    width: 100%;
  }

  .otp-input {
    width: 50px !important;
    height: 60px !important;
    border: 1.5px solid rgba(0, 0, 0, 0.1) !important;
    border-radius: var(--radius-md) !important;
    background: rgba(0, 0, 0, 0.02) !important;
    font-size: 24px !important;
    font-weight: 600 !important;
    color: var(--waya-red) !important;
    transition: var(--transition-smooth) !important;
    outline: none !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);

    &:focus {
      border-color: var(--waya-red) !important;
      background: #fff !important;
      box-shadow: 0 8px 16px rgba(231, 71, 44, 0.08) !important;
      transform: translateY(-2px);
    }
  }

  .resend-link {
    color: var(--waya-red);
    font-weight: 500;
    font-size: 14px;
    transition: var(--transition-smooth);
    text-decoration: none;

    &:hover {
      color: var(--waya-red-hover);
      text-decoration: underline;
    }
  }

  .reset-link {
    color: var(--text-muted);
    font-size: 13px;
    margin-top: 16px;
    display: inline-block;
    transition: var(--transition-smooth);

    &:hover {
      color: var(--text-main);
    }
  }
`;

export default Wrapper;
